import { TemplateData } from './htmlTemplates';

export const watercolorSoftTemplate = {
  id: 'watercolor-soft',
  name: '水彩柔和',
  description: '水彩风格，适合艺术和温馨内容',
  category: 'artistic',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: linear-gradient(135deg, #fef9e7, #fdf2e9, #f8f9fa);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 50px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .watercolor-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: 
            radial-gradient(ellipse at 20% 30%, ${data.theme.primaryColor}15 0%, transparent 50%),
            radial-gradient(ellipse at 80% 20%, ${data.theme.accentColor}20 0%, transparent 60%),
            radial-gradient(ellipse at 60% 80%, ${data.theme.primaryColor}10 0%, transparent 40%),
            radial-gradient(ellipse at 30% 70%, ${data.theme.accentColor}15 0%, transparent 50%);
          filter: blur(40px);
          opacity: 0.6;
        }

        .brand-soft {
          position: absolute;
          top: 35px;
          right: 35px;
          font-size: 16px;
          color: ${data.theme.primaryColor}80;
          font-weight: 300;
          z-index: 2;
        }

        .title {
          font-size: 38px;
          font-weight: 600;
          color: #2c3e50;
          text-align: center;
          line-height: 1.3;
          margin-bottom: 35px;
          letter-spacing: 0.5px;
          position: relative;
          z-index: 2;
        }

        .title-watercolor {
          background: linear-gradient(45deg, ${data.theme.primaryColor}, ${data.theme.accentColor});
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          position: relative;
          font-weight: 700;
        }

        .title-watercolor::before {
          content: '';
          position: absolute;
          top: -10px;
          left: -10px;
          right: -10px;
          bottom: -10px;
          background: radial-gradient(ellipse, ${data.theme.primaryColor}20 0%, transparent 70%);
          border-radius: 50%;
          z-index: -1;
          filter: blur(15px);
        }

        .subtitle {
          font-size: 16px;
          color: #5d6d7e;
          text-align: center;
          line-height: 1.6;
          font-weight: 300;
          position: relative;
          z-index: 2;
          max-width: 280px;
        }

        .soft-highlight {
          background: linear-gradient(45deg, ${data.theme.accentColor}30, ${data.theme.primaryColor}20);
          color: ${data.theme.primaryColor};
          padding: 2px 6px;
          border-radius: 12px;
          font-weight: 500;
          margin: 0 1px;
          box-shadow: 0 2px 8px ${data.theme.accentColor}20;
        }

        .watercolor-splash {
          position: absolute;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          filter: blur(20px);
          opacity: 0.4;
        }

        .splash-1 {
          top: 80px;
          left: 30px;
          background: radial-gradient(circle, ${data.theme.primaryColor}40 0%, transparent 70%);
          animation: float 6s ease-in-out infinite;
        }

        .splash-2 {
          bottom: 120px;
          right: 40px;
          background: radial-gradient(circle, ${data.theme.accentColor}50 0%, transparent 70%);
          animation: float 8s ease-in-out infinite reverse;
        }

        .splash-3 {
          top: 50%;
          left: 20px;
          transform: translateY(-50%);
          background: radial-gradient(circle, ${data.theme.primaryColor}30 0%, transparent 60%);
          animation: float 7s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-20px) scale(1.1);
          }
        }

        .delicate-line {
          position: absolute;
          bottom: 80px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 1px;
          background: linear-gradient(90deg, transparent, ${data.theme.primaryColor}60, transparent);
        }

        .delicate-line::before,
        .delicate-line::after {
          content: '';
          position: absolute;
          top: 50%;
          width: 4px;
          height: 4px;
          background: ${data.theme.accentColor};
          border-radius: 50%;
          transform: translateY(-50%);
        }

        .delicate-line::before {
          left: -10px;
        }

        .delicate-line::after {
          right: -10px;
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="watercolor-bg"></div>
        <div class="brand-soft">${data.theme.logo}</div>
        
        <div class="watercolor-splash splash-1"></div>
        <div class="watercolor-splash splash-2"></div>
        <div class="watercolor-splash splash-3"></div>
        
        <h1 class="title">
          ${data.title.split(' ').map((word, i) => 
            i === Math.floor(data.title.split(' ').length / 2) ? `<span class="title-watercolor">${word}</span>` : word
          ).join(' ')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{3,6})/g, '<span class="soft-highlight">$1</span>')}</p>
        
        <div class="delicate-line"></div>
      </div>
    </body>
    </html>
  `
};
